import React from 'react';
import SkillSlider from './skillslider';
import '../styles/SelfIntro.css';

const styles = {
    gridContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      gap: '20px',
      padding: '20px',
    },
  };
  
const SelfIntro = () => {
  return (
    <div className="basic-container">
      <div className="heading">About Me</div>
      <div className="about-me">
      I’m a tech-oriented Urban Designer, Planner, and Researcher, specializing in computational design and data science. 
      With a background in architecture, urban design, and spatial analysis, I apply cutting-edge technology to develop impactful urban projects. 
      </div>

      <div className="skills-container">
        <div className="skill-category">
          <h3>Planning, Urban Design & Architecture</h3>
          <SkillSlider skill="3D Modelling(Rhino/Sketchup)" level={85} />
          <SkillSlider skill="Adobe Illustrator" level={90} />
          <SkillSlider skill="Adobe InDesign" level={80} />
          <SkillSlider skill="Adobe Photoshop" level={75} />
          <SkillSlider skill="GIS(QGIS/ArcGIS) Analysis" level={80} />
        </div>

        <div className="skill-category">
          <h3>Data Science, Programming & Development</h3>
          <SkillSlider skill="Python Programming" level={80} />
          <SkillSlider skill="Machine Learning(Deep Learning)" level={76} />
          <SkillSlider skill="Grasshopper SDK" level={70} />
          <SkillSlider skill="Data Structures and Algorithms" level={78} />
          <SkillSlider skill="Web Development & Design" level={60} />
        </div>
      </div>
    </div>
  );
};

export default SelfIntro;